import { render, staticRenderFns } from "./conferenceInfo.vue?vue&type=template&id=aa382114&scoped=true&lang=pug&"
import script from "./conferenceInfo.vue?vue&type=script&lang=js&"
export * from "./conferenceInfo.vue?vue&type=script&lang=js&"
import style0 from "./conferenceInfo.vue?vue&type=style&index=0&id=aa382114&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa382114",
  null
  
)

export default component.exports